import React from 'react'
import { Table, useMediaSize } from '@ally/metronome-ui'
import {
  sortWealthAccountsGroup,
  getSortedInvwAccountsWithOverview,
} from './utils'
import { useAccountTypes } from '../../../providers'
import { useCustomizeDashboard } from '../../../Customizations/customizationContext/CustomizeDashboardContext'
import { hasStaleAccounts, isAccountClosed } from '../../../utils'
import {
  AccountCard,
  AccountCardMbox,
  AccountGroup,
  NonPrintingWrapper,
} from '../../Shared'
import { useHostServices } from '../../../HostServices'
import { getColumns } from './TableColumns'
import MobileInvestAccountList from '../../MobileAccountsCard/MobileInvestAccountList'

export const WealthManagement: React.FC = () => {
  const {
    isWealthPartialOutage,
    isWealthProspect,
    investAccounts,
  } = useAccountTypes()
  const [{ dashboardView }] = useCustomizeDashboard()
  const invwAccountsGroup = investAccounts.filter(
    account => account.type === 'INVW',
  )
  const sortedInvwAccounts = sortWealthAccountsGroup(invwAccountsGroup)
  const isLgDown = useMediaSize('LgDown')
  const isMdDown = useMediaSize('MdDown')
  const isPrint = window.matchMedia('print').matches

  const hasOnlyClosedAccounts = sortedInvwAccounts.every(isAccountClosed)

  const hasStaleData = hasStaleAccounts(investAccounts)

  const sortedInvwAccountsWithOverview = getSortedInvwAccountsWithOverview(
    sortedInvwAccounts,
  )

  const { featureFlags } = useHostServices()
  const isPersonalAdvisorEnabled = featureFlags.variation(
    'FF_personal-advisor',
    false,
  )

  const areWealthPercentagesEnabled = featureFlags.variation(
    'FF_wealth-percentages',
    false,
  )

  const captionCopy = isPersonalAdvisorEnabled
    ? `Information about your Ally Personal Advice accounts`
    : `Information about your Ally Wealth Management accounts`

  return (
    <>
      {sortedInvwAccounts.length > 0 ? (
        <AccountGroup name="wealth-client">
          <AccountCard type="INVW" allClosedAccounts={hasOnlyClosedAccounts}>
            {isMdDown && !isPrint ? (
              <MobileInvestAccountList
                accounts={sortedInvwAccountsWithOverview}
                allClosedAccounts={hasOnlyClosedAccounts}
                hasStaleData={hasStaleData}
              />
            ) : (
              <Table
                config={{
                  data: sortedInvwAccountsWithOverview,
                  columns: getColumns({
                    hasOnlyClosedAccounts,
                    isLgDown,
                    isWealthPartialOutage,
                    view: dashboardView,
                    hasStaleData,
                    isPersonalAdvisorEnabled,
                    areWealthPercentagesEnabled,
                  }),
                }}
                shared={{
                  captionText: captionCopy,
                  disableContainer: true,
                }}
                table={{
                  fullWidth: true,
                  footer: {
                    enabled: !hasOnlyClosedAccounts,
                  },
                }}
                data-testid="wealth-accounts-table"
              />
            )}
            {!isWealthProspect && (
              <NonPrintingWrapper>
                <AccountCardMbox name="ally-dashboard-wealth-well" />
              </NonPrintingWrapper>
            )}
          </AccountCard>
        </AccountGroup>
      ) : null}
    </>
  )
}
